'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('actionItemAnimationSvc', actionItemAnimationSvc);

  /* @ngInject */
  function actionItemAnimationSvc() {
    return {
      animations: {
        burstAni: burstAni,
        faderTween: faderTween,
        showHideModalTween: showHideModalTween,
        popInTween: popInTween
      },
      elementToCoords: elementToCoords
    };

    function burstAni(burstTargetEl) {
      return new mojs.Burst({
        parent: burstTargetEl[0],
        duration: 1500,
        delay: 0,
        shape: 'circle',
        fill: '#4caf50',
        x: '0px',
        y: burstTargetEl.height() - 10 + 'px',
        opacity: 0.6,
        childOptions: { radius: { 6: 0 } },
        radius: { 4: 20 },
        count: 6,
        isSwirl: true,
        isRunLess: true,
        easing: mojs.easing.bezier(0.1, 1, 0.3, 1)
      });
    }

    function faderTween(faderEl, fadeIn) {
      return new TWEEN.Tween({ opacity: fadeIn ? 0 : 1 }).to({ opacity: fadeIn ? 1 : 0 }, 600).delay(200).easing(TWEEN.Easing.Cubic.InOut).onUpdate(function (opacityObject) {
        faderEl.css({
          opacity: opacityObject.opacity
        });
      });
    }

    function showHideModalTween(modalEl, openIt) {
      return new TWEEN.Tween({ y: elementToCoords(modalEl).translate.y }).to({ y: openIt ? 0 : 100 }, 600).delay(200).easing(TWEEN.Easing.Cubic.InOut).onUpdate(function (translateObject) {
        modalEl.css({
          transform: 'translateX(' + elementToCoords(modalEl).translate.x + 'px) translateY(' + translateObject.y + 'vh)'
        });
      });
    }

    function popInTween(popInTargetEl) {
      return new TWEEN.Tween({ opacity: 0, scale: 0.6 }).to({ opacity: 1, scale: 1 }, 300).easing(_swingTo).onUpdate(function (opacityObject) {
        popInTargetEl.css({
          opacity: opacityObject.opacity,
          transform: 'scale(' + opacityObject.scale + ')'
        });
      });
    }

    // Gets the bounding box around an element, along with the translate values.
    // Together, these can be used to find the exact pixels in the viewport that the element takes up.
    function elementToCoords(element) {
      return {
        x: element[0].getBoundingClientRect().left,
        y: element[0].getBoundingClientRect().top,
        translate: _matrixToTransformObj(element.css('transform')).translate
      };
    }

    ////////////////////////////
    // Private Functions
    ////////////////////////////


    // Custom easing function
    function _swingTo(t) {
      var s = 1.2;
      return (t - 1) * (t - 1) * (t * (s + 1) - 1) + 1;
    }

    // The transform property is a string, and you need to parse the string to get the translate values out.
    // https://stackoverflow.com/a/8601967
    function _matrixToTransformObj(matrix) {
      if (matrix === 'none') {
        matrix = 'matrix(0,0,0,0,0)';
      }
      var obj = {},
          values = matrix.match(/([-+]?[\d\.]+)/g);

      obj.rotate = Math.round(Math.atan2(parseFloat(values[1]), parseFloat(values[0])) * (180 / Math.PI)) || 0;
      obj.translate = {
        x: values[4] ? parseFloat(values[4]) : 0,
        y: values[5] ? parseFloat(values[5]) : 0
      };

      return obj;
    }
  }
})();